// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"Home_imgContainer__21xBm","img":"Home_img__3Hk9w","title":"Home_title__idnpY","descriptionContainer":"Home_descriptionContainer__1iQOJ"};